import Navbar from "../components/Navbar";
import ProductCard from "../components/ProductCard";
import ProductPreview from "../components/ProductPreview";
import ProductSidebar from "../components/ProductSidebar";
import { Pagination } from "@mantine/core";
import "../Styles/Product.css";
import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import axios from "axios";
import { url } from "../db/url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Product = () => {
  const [activePage, setPage] = useState(1);
  const [productPreview, setProductPreview] = useState(false);
  const [category, setCategory] = useState(null)
  const [data, setData] = useState({})
  const [products, setProduct] = useState([])
  const naviagte = useNavigate()

  const handleChange = (event) => {
    setCategory(event.target.value)

  }


    useEffect(() => {
        axios.get(`${url}/api/v2/product/get-all-products`)
        .then(res => {
           
            setProduct(res.data.products)
        }).catch(err => {
          //  console.log(err)
            toast.error(err.response ? err.response.data.message : "Network Error")
        })
    }, [])

  

  function filteredData(products, selected) {
    let filteredProducts = products;

    // Applying selected filter
    if (selected) {
      filteredProducts = filteredProducts.filter(
        ({ category, rating, discountPrice}) =>
          category === selected ||
          Math.round(rating) === selected ||
          discountPrice <= selected
      );
    }
    return filteredProducts
  }

  const result = filteredData(products, category);

  const openProductPreview = (data) => {
    setProductPreview(true);
    setData(data)
  };

  const closeProductPreview = () => {
    setProductPreview(false);
  };

  return (
    <>
      <Navbar />

      <div className="product">

        <ProductSidebar handleChange={handleChange}/>

        <section className="productCardWrapper">
            <div className="cards">
            {
              result.length === 0 ? 
              <p className="empty">No Available Products</p>
              : 
              result.map((data) => {
                return(
                  <div className="card" onClick={()=> openProductPreview(data)}>
                    <ProductCard 
                        img={data.images[0].url}
                        name={data.name}
                        prevPrice={data.originalPrice}
                        price={data.discountPrice}
                        rating={data.ratings}
                    />
                  </div>
                )
              }  )
            }
            </div>
            {/* <section className="productPagination">
            <Pagination
                total={10}
                value={activePage}
                onChange={setPage}
                boundaries={1}
                color="rgb(2, 79, 2)"
                size={window.innerWidth <= 400 ? "xs" : "md"}
                className="paginate"
            />
            </section> */}
        </section>
      </div>

      {/* <ServiceCard/> */}

      <section>
        <ProductPreview modal={productPreview} data={data} onClose={closeProductPreview} />
      </section>
      <Footer />
    </>
  );
};

export default Product;
